import React, { FC, useEffect } from 'react';
import i18n from 'i18next';
import axios from 'axios';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import { ParentProps } from '../models';

export const TranslationProvider: FC<ParentProps> = (props) => {
  const {
    children,
  } = props;

  const i18nInit = async () => {
    const lang = navigator?.language?.substring(0, 2);

    let translation = null;

    if (lang !== 'en') {
      try {
        const transReq = await axios(`/locales/${lang}.json`);
        translation = transReq?.data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    i18n
      .use(initReactI18next)
      .init({
        resources: { [lang]: { translation } },
        lng: lang,
        fallbackLng: 'en',
      });
  };

  useEffect(() => {
    i18nInit();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
};
